import AbstractService from "./abstract.service"
import ProjectTransformer, { baseUri } from "@/transformers/project.transformer"

class ProjectService extends AbstractService {
  constructor() {
    super({ baseUri, transformer: ProjectTransformer })
  }
}

const projectService = new ProjectService()
export default projectService
